import type { ReactNode } from "react";

export type BadgeTone =
  | "amber"
  | "blue"
  | "green"
  | "red"
  | "gray"
  | "orange"
  | "teal";

const toneClasses: Record<BadgeTone, string> = {
  amber: "bg-[#FFF9EB] text-[#B45309]",
  blue: "bg-[#EFF6FF] text-[#1D4ED8]",
  green: "bg-[#E8F9F0] text-[#27AE60]",
  red: "bg-[#FFF5F5] text-[#E74C3C]",
  gray: "bg-[#F0FDFD] text-[#6B8A8A]",
  orange: "bg-[#FFF5E6] text-[#D97706]",
  teal: "bg-[#E8F6F6] text-ghasla-text-link",
};

interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
  pulse?: boolean;
}

export default function Badge({ tone = "gray", children, className = "", pulse = false }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium whitespace-nowrap ${toneClasses[tone]} ${className} ${pulse ? "animate-pulse" : ""}`}
    >
      {children}
    </span>
  );
}